import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconZendesk from '@/icons/Zendesk.svg';

export const RequestSentToZendeskActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_sent_to_zendesk'>;
}) => {
  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="neutral"
      icon={<IconZendesk />}
      message={
        <BaseActivityText>
          <Trans id="activities.request_sent_to_zendesk.message">
            The request has been transferred to Zendesk
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
